// extracted by mini-css-extract-plugin
export default {"content":"Inicio_content__asecv"};